// @ts-nocheck
import {
  CLEAR_MESSAGE,
  GET_DELETED_USERS_FAILURE,
  GET_DELETED_USERS_REQUEST,
  GET_DELETED_USERS_SUCCESS,
  PERMANENT_DELETE_ELGIBLE_FAILURE,
  PERMANENT_DELETE_ELGIBLE_REQUEST,
  PERMANENT_DELETE_ELGIBLE_SUCCESS,
  PERMANENT_DELETE_USER_FAILURE,
  PERMANENT_DELETE_USER_REQUEST,
  PERMANENT_DELETE_USER_SUCCESS,
  RECOVER_DELETED_USER_FAILURE,
  RECOVER_DELETED_USER_REQUEST,
  RECOVER_DELETED_USER_SUCCESS,
} from "../constants/deletedUsers";

const initialState = {
  users: [],
  searchString: "",
  totalPages: 1,
  currentPage: 1,
  limit: 10,
  isLoading: false,
  message: "",
  permanentDeleteEligibleUsers: [],
};

const deletedUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DELETED_USERS_REQUEST:
      return {
        ...state,
        searchString: action.payload,
        isLoading: true,
      };
    case GET_DELETED_USERS_SUCCESS:
      return {
        ...state,
        users: action?.payload?.data,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
        limit: action?.payload?.meta?.pageSize,
        isLoading: false,
      };
    case GET_DELETED_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case RECOVER_DELETED_USER_REQUEST:
      return state;
    case RECOVER_DELETED_USER_SUCCESS:
      return {
        ...state,
        message: action?.payload?.message,
      };
    case RECOVER_DELETED_USER_FAILURE:
      return {
        ...state,
        message: action?.payload?.message,
      };
    case CLEAR_MESSAGE:
      return {
        ...state,
        message: "",
      };
    case PERMANENT_DELETE_USER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case PERMANENT_DELETE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case PERMANENT_DELETE_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case PERMANENT_DELETE_ELGIBLE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case PERMANENT_DELETE_ELGIBLE_SUCCESS:
      // console.log(action?.payload)
      // console.log(state.permanentDeleteEligibleUsers)
      const userExists = state.permanentDeleteEligibleUsers.some(
        (user) => user.userId === action.payload.userId,
      );
      // console.log("cjecking if user exists")
      // console.log(userExists)
      return {
        ...state,

        permanentDeleteEligibleUsers: userExists
          ? state.permanentDeleteEligibleUsers // Return the array as is if user exists
          : [...state.permanentDeleteEligibleUsers, action?.payload],
        isLoading: false,
      };
    case PERMANENT_DELETE_ELGIBLE_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

export { deletedUsersReducer };
export { initialState };
